// extracted by mini-css-extract-plugin
export default {"body-1":"RQvOd0k4kLH8R9mIbwUw","body-2":"Sugo3mTAHKRskIf9aPxT","body-3":"qo5z9BeIS2GAu_ZaWkkt","ant-typography":"ost3K2xdCyF0VxXTOfLQ","exportSettingsButton":"GotzIS0pYHEuCshSL3Zv"};